const state = () => ({
    currentJobId: null,
    currentJob: null,
    currentJobLoading: false,
    pollHandle: null,
    jobsList: [],
    jobsListTotal: 0,
    jobsListLoading: false,
    uploadInFlight: false,
    videoCurrentUploadId: null,
    videoCurrentUpload: null,
    videoCurrentUploadLoading: false,
    videoPollHandle: null,
    videoUploadsList: [],
    videoUploadsListTotal: 0,
    videoUploadsListLoading: false,
    videoUploadInFlight: false,
    scenariosList: [],
    scenariosListLoading: false,
    alarmsList: [],
    alarmsListLoading: false,
    alarmsListTotal: 0,
    systemConfig: [],
    systemConfigLoading: false,
    exclusionsList: [],
    exclusionsListLoading: false,
    personDetail: null,
    personDetailLoading: false,
    personMatchHistory: [],
    personMatchHistoryLoading: false,
    coPresenceData: null,
    coPresenceLoading: false,
    coPresenceKimlikno: null
});

export default state;
